var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerClass"},[_c('div',{staticClass:"text-h2"},[_vm._v(" 🤬 ")]),_c('div',{staticClass:"messageClass"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }